'use strict';

var EventSubscription = function () {
  function EventSubscription(subscriber) {
    this.subscriber = subscriber;
  }

  var _proto = EventSubscription.prototype;

  _proto.remove = function remove() {
    this.subscriber.removeSubscription(this);
  };

  return EventSubscription;
}();

export default EventSubscription;